import { render, staticRenderFns } from "./MessListReminderTable.vue?vue&type=template&id=f00260f8&scoped=true&"
import script from "./MessListReminderTable.vue?vue&type=script&lang=js&"
export * from "./MessListReminderTable.vue?vue&type=script&lang=js&"
import style0 from "./MessListReminderTable.vue?vue&type=style&index=0&id=f00260f8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00260f8",
  null
  
)

export default component.exports